var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 18,
    viewBox: "0 0 12 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.00008 15.1766C1.00008 16.2137 1.75008 17.0623 2.66675 17.0623H9.33341C10.2501 17.0623 11.0001 16.2137 11.0001 15.1766V3.86263H1.00008V15.1766ZM11.8334 1.03414H8.91675L8.08341 0.0913086H3.91675L3.08341 1.03414H0.166748V2.9198H11.8334V1.03414Z",
    fill: "#E3E3E3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/deleteIcon.79de9fb39a176377dd481ec1d4d1ec60.svg";
export { ForwardRef as ReactComponent };